import React from 'react';
import { Outlet } from 'react-router';
import PropTypes from 'prop-types';
import { CatTripNavOptions } from '../../constants/CatTripNavOptions';
import HomeHeader from './HomeHeader';
import DemandLandscapeHeader from './DemandLandscapeHeader';
import CatTripHomeHeader from './CatTripHeaderNav';
import Footer from './Footer';

function UserGuideLayout({ previousPage }) {
  const getPreviousPage = () => {
    return previousPage;
  };

  const renderHeader = () => {
    const prevPage = getPreviousPage();

    if (prevPage?.includes('categories')) {
      return <CatTripHomeHeader navOptions={CatTripNavOptions.categoryStructureNavOptions} />;
    } else if (prevPage?.includes('trip-types')) {
      return <CatTripHomeHeader navOptions={CatTripNavOptions.tripTypesNavOptions} />;
    } else if (prevPage?.includes('demand-landscape')) {
      return <DemandLandscapeHeader />;
    } else {
      return <HomeHeader />;
    }
  };

  return (
    <div className="container">
      {renderHeader()}
      <Outlet context={{ getPreviousPage }} />
      <Footer />
    </div>
  );
}

UserGuideLayout.propTypes = {
  previousPage: PropTypes.string
};

export default UserGuideLayout;
